import { Box, BoxProps, Container, Flex, Grid, Heading, Link } from '@chakra-ui/react';
import { CMS } from '@waitroom/models';
import { ReactElement } from 'react';
import CmsVideoOrImage from '../../../../cms/components/VideoOrImage/VideoOrImage';

const px = { base: 2, sm: 4, lg: 6, xl: 8 };

const Investors = ({ heading, items, ...rest }: CMS.Investors & BoxProps): ReactElement | null => {
  if (!items?.length) return null;
  return (
    <Box w="100%" data-testid="investors" {...rest}>
      <Container maxW="container.2xl">
        {!!heading && (
          <Heading fontWeight="bold" size="3xl" color="gray.300" mb={8} textAlign="center">
            {heading}
          </Heading>
        )}
        <Grid
          templateColumns={{ base: 'repeat(2, 1fr)', lg: 'repeat(4, 1fr)' }}
          alignItems="center"
          justifyItems="center"
        >
          {items.map((item, i) => (
            <Flex
              key={i}
              alignItems="center"
              minH="150px"
              px={px}
              transform="opacity .2s ease-in"
              _hover={{ opacity: 0.8 }}
            >
              <Link
                href={item.url}
                key={i}
                target="_blank"
                rel="noopener noreferrer"
                className="none"
                title={item.name}
                p={2}
                transform="opacity .15s ease-in"
                _hover={{ opacity: 0.9 }}
              >
                <CmsVideoOrImage image={item.image} w="100%" h="auto" rounded={0} />
              </Link>
            </Flex>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};
export default Investors;
